import { useNavigate } from "@tanstack/react-router";
import { Plus, Wine } from "lucide-react";

import { Button } from "../../ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "../../ui/empty";

export const ItemsEmptyState = ({ menuId }: { menuId: string }) => {
  const navigate = useNavigate();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Wine />
        </EmptyMedia>
        <EmptyTitle>No items in this menu yet</EmptyTitle>
        <EmptyDescription>
          Items you add to categories will appear here. Get started by adding
          your first item.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        {/* V4.1: Route-based create for URL context tracking */}
        <Button
          onClick={() => navigate({ to: `/menus/${menuId}/items/new` })}
          type="button"
          variant="secondary"
        >
          <Plus className="text-foreground size-5" />
          Add Item
        </Button>
      </EmptyContent>
    </Empty>
  );
};
